import React, {useContext} from 'react';
import {Link} from 'react-router-dom';
import {Alert, Button, Form} from 'react-bootstrap';
import AuditContext from '../Utils/context.js';

export default function Proof() {

  const disabledStatus = [
    'EVALUATED',
    'VISITED',
    'APPROVED',
    'COMPLETED'
  ];

  const {schedule} = useContext(AuditContext);

  const getVariant = (form) => {

    switch (true) {
      case (form?.EVALUATE_AT !== null && form?.EVALUATE_BY !== null):
        return 'success';
      case (form?.SUBMIT_AT !== null && form?.SUBMIT_BY !== null):
        return 'primary';
      default:
        return 'secondary';
    }
  }

  return (
    <>
      <h3>Evaluation</h3>
      <Form.Group>
        {schedule.forms && schedule.forms.map((form, key) => {
          if (form.SUBMIT_BY === null) {
            return (
              <Link key={key} to={`/admin/proofs/${form.FORM_ID}`}>
                <Button variant={getVariant(form)}>{form.criteria.CRITERIA_CODE}. {form.criteria.CRITERIA_LABEL}</Button> {' '}
              </Link>
            );
          } else {
            return (
              <Link key={key} to={`/admin/evaluations/${form.FORM_ID}`}>
                <Button variant={getVariant(form)}>{form.criteria.CRITERIA_CODE}. {form.criteria.CRITERIA_LABEL}</Button> {' '}
              </Link>
            );
          }
        })}
      </Form.Group>
      <Form.Group>
        {!disabledStatus.includes(schedule.SCHEDULE_STATUS)
          ? <Alert style={{textAlign: 'center'}} variant="info">Evaluation is in progress.</Alert>
          : <Alert style={{textAlign: 'center'}} variant="info">Evaluation Process has been completed.</Alert>
        }
      </Form.Group>
      <Form.Group>
        {schedule?.FORM_FILE ? (
          <a
            href={`${process.env.REACT_APP_API_HOST}schedules/${schedule.SCHEDULE_ID}/download`}
            className="btn" style={{backgroundColor:'#003D73'}}
            >
              Download Submitted Spreadsheet
            </a>
            ) : (<p></p>)}
      </Form.Group>
    </>
  )
}